
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
directives: {
TransferDom
},
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
async expend () {
if (this.expendClass === 'fa fa-angle-double-up') {
this.queryResult = []
this.expendClass = 'fa fa-angle-double-down'
this.dropdownTitle = '展开CIQ编码'
return
}
try {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/CIQCODE/SearchCIQByCodeTS'
, {params: {codets: this.$route.query.p_code}})
this.queryResult = queryPromise.data
this.$vux.loading.hide()
if (this.queryResult.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'})
return
}
this.expendClass = 'fa fa-angle-double-up'
this.dropdownTitle = '收起CIQ编码'
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
}
},
data () {
return {
currentItem: null,
queryResult: [],
expendClass: 'fa fa-angle-double-up',
dropdownTitle: '展开CIQ编码'
}
},
async activated () {
try {
this.$vux.loading.show({ text: ' 数据载入中' })
const queryPromise = await this.$http.get('/API/CIQCODE/SearchCIQByCodeTS'
, {params: {codets: this.$route.query.p_code}})
this.queryResult = queryPromise.data
this.$vux.loading.hide()
if (this.queryResult.length === 0) {
this.$vux.alert.show({
title: '通知',
content: '没有符合条件的记录'})
return
}
this.expendClass = 'fa fa-angle-double-up'
this.dropdownTitle = '收起CIQ编码'
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
}
}



// WEBPACK FOOTER //
// ./src/components/CiqDetail.vue